import { render, staticRenderFns } from "./NotificationReplaceModal.vue?vue&type=template&id=5c91a731&scoped=true&"
import script from "./NotificationReplaceModal.vue?vue&type=script&lang=js&"
export * from "./NotificationReplaceModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationReplaceModal.vue?vue&type=style&index=0&id=5c91a731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91a731",
  null
  
)

export default component.exports